import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publicheader',
  templateUrl: './publicheader.component.html',
  styleUrls: ['./publicheader.component.css']
})
export class PublicheaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
